/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getPerson$Json } from '../fn/person/get-person-json';
import { GetPerson$Json$Params } from '../fn/person/get-person-json';
import { getPerson$Plain } from '../fn/person/get-person-plain';
import { GetPerson$Plain$Params } from '../fn/person/get-person-plain';
import { getPersons$Json } from '../fn/person/get-persons-json';
import { GetPersons$Json$Params } from '../fn/person/get-persons-json';
import { getPersons$Plain } from '../fn/person/get-persons-plain';
import { GetPersons$Plain$Params } from '../fn/person/get-persons-plain';
import { PersonContextCto } from '../models/person-context-cto';
import { updatePerson$Json } from '../fn/person/update-person-json';
import { UpdatePerson$Json$Params } from '../fn/person/update-person-json';
import { updatePerson$Plain } from '../fn/person/update-person-plain';
import { UpdatePerson$Plain$Params } from '../fn/person/update-person-plain';
import { updateUserAssociation$Json } from '../fn/person/update-user-association-json';
import { UpdateUserAssociation$Json$Params } from '../fn/person/update-user-association-json';
import { updateUserAssociation$Plain } from '../fn/person/update-user-association-plain';
import { UpdateUserAssociation$Plain$Params } from '../fn/person/update-user-association-plain';

@Injectable({ providedIn: 'root' })
export class PersonService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPerson()` */
  static readonly GetPersonPath = '/person/{personGuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPerson$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPerson$Plain$Response(params: GetPerson$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonContextCto>> {
    return getPerson$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPerson$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPerson$Plain(params: GetPerson$Plain$Params, context?: HttpContext): Observable<PersonContextCto> {
    return this.getPerson$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PersonContextCto>): PersonContextCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPerson$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPerson$Json$Response(params: GetPerson$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonContextCto>> {
    return getPerson$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPerson$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPerson$Json(params: GetPerson$Json$Params, context?: HttpContext): Observable<PersonContextCto> {
    return this.getPerson$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PersonContextCto>): PersonContextCto => r.body)
    );
  }

  /** Path part for operation `updatePerson()` */
  static readonly UpdatePersonPath = '/person/{personGuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePerson$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updatePerson$Plain$Response(params: UpdatePerson$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonContextCto>> {
    return updatePerson$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePerson$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updatePerson$Plain(params: UpdatePerson$Plain$Params, context?: HttpContext): Observable<PersonContextCto> {
    return this.updatePerson$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PersonContextCto>): PersonContextCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePerson$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updatePerson$Json$Response(params: UpdatePerson$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonContextCto>> {
    return updatePerson$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePerson$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updatePerson$Json(params: UpdatePerson$Json$Params, context?: HttpContext): Observable<PersonContextCto> {
    return this.updatePerson$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PersonContextCto>): PersonContextCto => r.body)
    );
  }

  /** Path part for operation `getPersons()` */
  static readonly GetPersonsPath = '/person/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPersons$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPersons$Plain$Response(params?: GetPersons$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PersonContextCto>>> {
    return getPersons$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPersons$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPersons$Plain(params?: GetPersons$Plain$Params, context?: HttpContext): Observable<Array<PersonContextCto>> {
    return this.getPersons$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PersonContextCto>>): Array<PersonContextCto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPersons$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPersons$Json$Response(params?: GetPersons$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PersonContextCto>>> {
    return getPersons$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPersons$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPersons$Json(params?: GetPersons$Json$Params, context?: HttpContext): Observable<Array<PersonContextCto>> {
    return this.getPersons$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PersonContextCto>>): Array<PersonContextCto> => r.body)
    );
  }

  /** Path part for operation `updateUserAssociation()` */
  static readonly UpdateUserAssociationPath = '/person/{personGuid}/user-association';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserAssociation$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateUserAssociation$Plain$Response(params: UpdateUserAssociation$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonContextCto>> {
    return updateUserAssociation$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserAssociation$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateUserAssociation$Plain(params: UpdateUserAssociation$Plain$Params, context?: HttpContext): Observable<PersonContextCto> {
    return this.updateUserAssociation$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PersonContextCto>): PersonContextCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserAssociation$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateUserAssociation$Json$Response(params: UpdateUserAssociation$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonContextCto>> {
    return updateUserAssociation$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserAssociation$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateUserAssociation$Json(params: UpdateUserAssociation$Json$Params, context?: HttpContext): Observable<PersonContextCto> {
    return this.updateUserAssociation$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PersonContextCto>): PersonContextCto => r.body)
    );
  }

}
